import http from "./http-common";

const update = (data) => {
  return http.patch(`/updateProfile`, data);
};
const UserUpdateService = {
  update
};

export default UserUpdateService;